import * as React from 'react'

import Baseline from '@eversports/klimt-design-components/Baseline'
import theme from '@eversports/klimt-design-components/theme'
import ThemeProvider from '@eversports/klimt-design-components/ThemeProvider'

const CompactKlimtWrapper = ({ children }: React.PropsWithChildren<unknown>) => {
  return (
    <ThemeProvider theme={theme}>
      <Baseline />
      {children}
    </ThemeProvider>
  )
}

export default CompactKlimtWrapper
